import { render, staticRenderFns } from "./MenuNavigation.vue?vue&type=template&id=0a271b7a&scoped=true&"
import script from "./MenuNavigation.vue?vue&type=script&lang=ts&"
export * from "./MenuNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./MenuNavigation.vue?vue&type=style&index=0&id=0a271b7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a271b7a",
  null
  
)

export default component.exports